import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAznB36znxKn5rEeuaUvakmI42I8zoqvtg",
  // authDomain: antes "auth.zeropending.com" (dominio personalizado) — el login con
  // Google usa signInWithRedirect, que manda al cliente a este dominio y necesita que
  // regrese cargando el "manejador" de autenticación de Firebase (una página que Firebase
  // sirve automáticamente). Con el dominio personalizado, esa página volvía en blanco —
  // eso es justo la pantalla blanca que viste antes de que te regresara al registro por
  // correo. El dominio de abajo (el que Firebase te da de fábrica) siempre tiene ese
  // manejador funcionando correctamente, sin depender de que el hosting/DNS del dominio
  // personalizado esté conectado del todo. Si más adelante querés recuperar el dominio
  // personalizado para el login, avisame y lo revisamos con calma en Firebase Console.
  authDomain: "zeropending-996a2.firebaseapp.com",
  projectId: "zeropending-996a2",
  storageBucket: "zeropending-996a2.firebasestorage.app",
  messagingSenderId: "465595773845",
  appId: "1:465595773845:web:de83568c821c15d7f17c9c",
  measurementId: "G-88543R8ZE4",
};

const app = initializeApp(firebaseConfig);

// ── App Check ────────────────────────────────────────────────────────────────
// Protege Firestore contra scripts que intenten hablar directo con la base de
// datos (saltándose la app real) — solo peticiones que vengan de zeropending.com,
// verificadas por reCAPTCHA v3 de forma invisible, pueden leer/escribir.
//
// En localhost (mientras desarrollás), Firebase bloquea todo por defecto salvo
// que agregues un "debug token" — si al probar en tu compu ves errores de
// App Check en la consola del navegador, avisame y lo agregamos.
//
// 15/ago/2026 — Sentry reportó "reCAPTCHA has already been rendered in this
// element": pasa si este archivo llega a ejecutarse dos veces en la misma
// carga de página (por ejemplo, con la recarga en caliente de "npm start"
// mientras se prueba en la compu — no debería pasarle nunca a un cliente real
// visitando el sitio ya publicado). Si igual llegara a pasar, App Check ya
// quedó protegiendo la app desde el primer intento, así que envolvemos esto
// en un try/catch: evita que ese segundo intento se reporte como un error
// real y asuste a alguien revisando Sentry.
try {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider("6LcDXnQtAAAAAExmbMaW3TBOjXTGW5H3PKX_yzUR"),
    isTokenAutoRefreshEnabled: true,
  });
} catch (e) {
  console.warn("App Check ya se había inicializado antes en esta página — se ignora el segundo intento.", e);
}

export const auth = getAuth(app);
export const db = getFirestore(app);
